import { Card, CardContent, CardHeader, IconButton, ListItem, ListItemIcon, ListItemText, Typography, CircularProgress } from "@mui/material";// FB  10077
import { useLocation, useNavigate } from "react-router-dom";
import { TestResult } from "../../../../store";
import ArrowBack from "@mui/icons-material/ArrowBack";
// FB  10077 - Begin
import { LoadingButton } from "@mui/lab";
import UseStyle from "../../../../css/styles";
import { GetResultDocuments, InsertPPLogs } from "../../../../api";
import { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Tooltip from "@mui/material/Tooltip";
// FB  10077 - End

// Update log
// FB  6192   02/06/2023  DK  Added page to handle test results acknowledgements
// FB  10077  02/13/2025  SK  Patient Portal Issues 2.6.25

export default function ResultAnnotation(props: any) {
    const navigate = useNavigate();
    const { state } = useLocation();
    const testresult = state as TestResult
    // FB  10077 - Begin
    const styles = UseStyle();
    const [loaderArray, setLoaderArray] = useState<Array<number>>([]);
    var JSAlert = require("js-alert");
    async function LoadTestResult(testresult: any) {
        setLoaderArray([...loaderArray, testresult.DocumentID]);
        let userName: any;
        let dataUser = sessionStorage.getItem("user");
        if (dataUser != null) {
            userName = JSON.parse(dataUser).Login;
        }
        const data = await GetResultDocuments(testresult.EMRID);
        if (data != undefined) {
            if (window.innerWidth <= 768) {
                JSAlert.alert("File downloaded successfully!", null, JSAlert.Icons.Success);
            }
            var file = new Blob([data], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        }
        setLoaderArray(loaderArray.filter((la) => la != testresult.DocumentID));
        InsertPPLogs(
            "Viewing Test Results Records",
            window.location.href,
            userName,
            ""
        );
    }
    // FB  10077 - End

    return (
        <div className='card' style={stylestart.container}>
            <ListItem>
                <ListItemIcon>
                    <IconButton onClick={() => navigate('/user/home/TestResults')}>
                        <ArrowBack />
                    </IconButton>
                </ListItemIcon>
                <ListItemText>
                    <Typography variant="h5">
                        <b>Test results</b>
                    </Typography>
                </ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>
                    <Typography variant="h6">
                        Physician message to patient
                    </Typography>
                </ListItemText>
            </ListItem>
            <div className='card' style={table.container}>
                <Card style={{ minWidth: 300, minHeight: 200, maxWidth: 500, maxHeight: 400 }}>
                    {/* FB  10077 - Begin */}
                    <CardHeader
                        title={"Test type: " + testresult.TestType}
                        action={
                            <LoadingButton
                                className={styles.textbutton}
                                loading={loaderArray.indexOf(testresult.DocumentID) > -1}
                                loadingPosition="center"
                                loadingIndicator={
                                    <CircularProgress size={20} style={{ color: "#083A4D" }} />
                                }
                                onClick={() => LoadTestResult(testresult)}
                            >
                                {!loaderArray.includes(testresult.DocumentID) &&
                                    <Tooltip title="View Document">
                                        <VisibilityIcon />
                                    </Tooltip>}
                            </LoadingButton>
                        }
                    />
                    {/* FB  10077 - End */}
                    <CardContent>
                        <div dangerouslySetInnerHTML={{ __html: testresult.Annotation }} />
                    </CardContent>
                </Card>
            </div>
        </div>
        // FB 1077- Removed Unused Part of Code
    );
}

const button = {
    container: {
        backgroundColor: '#083A4D',
        color: 'white',
    },
}

const stylestart = {
    container: {
        border: '1px grey',
        padding: '40px',
    },
}

const table = {
    container: {
        padding: '20px',
        border: 'white',
    },
}

const bottom = {
    container: {
        border: '1px grey',
        padding: '1px',
        width: '25rem'

    },
}